import { useMapEvents } from 'react-leaflet';
import type { LeafletEventHandlerFnMap } from 'leaflet';

function MapEventHandlerImpl({ handlers }: { handlers: LeafletEventHandlerFnMap }) {
  useMapEvents(handlers);

  return null;
}

export function MapEventHandler({ enabled, handlers }: { enabled: boolean, handlers: LeafletEventHandlerFnMap }) {
  if (!enabled) return null;
  return <MapEventHandlerImpl handlers={handlers} />;
}
